import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { formsApi } from './api/forms.api';
import { employeeAPI } from './api/employee.api.ts';
import { attachmentsApi } from './api/attachments.api';
import { approvalsApi } from './api/approvals.api';
import { qualityAndRiskApi } from './api/qualityandrisk.api';
import { legalWaiverApi } from './api/legalwaiver.api';
import { userApi } from './api/user.api.ts';
import { customerApi } from './api/customer.api.ts';
import { versionApi } from './api/version.api.ts';
import { featureFlagsApi } from './api/feature-flags.api.ts';
import { entityApi } from './api/entity.api.ts';
import { authReducer } from './slices/auth.slice.ts';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [userApi.reducerPath]: userApi.reducer,
    [formsApi.reducerPath]: formsApi.reducer,
    [employeeAPI.reducerPath]: employeeAPI.reducer,
    [attachmentsApi.reducerPath]: attachmentsApi.reducer,
    [approvalsApi.reducerPath]: approvalsApi.reducer,
    [qualityAndRiskApi.reducerPath]: qualityAndRiskApi.reducer,
    [legalWaiverApi.reducerPath]: legalWaiverApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [versionApi.reducerPath]: versionApi.reducer,
    [featureFlagsApi.reducerPath]: featureFlagsApi.reducer,
    [entityApi.reducerPath]: entityApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      // Upload mutations pass File + onProgress in meta.arg.originalArgs.
      // Keep RTK's default meta.arg ignore so those non-serializable values are skipped.
      serializableCheck: {
        ignoredActionPaths: ['meta.arg', 'meta.baseQueryMeta', 'payload.timestamp'],
        ignoredPaths: ['attachmentsApi.mutations'],
      },
    }).concat(
      userApi.middleware,
      formsApi.middleware,
      employeeAPI.middleware,
      attachmentsApi.middleware,
      approvalsApi.middleware,
      qualityAndRiskApi.middleware,
      legalWaiverApi.middleware,
      customerApi.middleware,
      versionApi.middleware,
      featureFlagsApi.middleware,
      entityApi.middleware
    );
  },
});

setupListeners(store.dispatch);

export type COIStore = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
